

























import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';
import moment from 'moment';
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";

@Component({
    name: 'b-exec-agr-hist-modal'
})
export default class BExecAgrHistModal extends AlterationI18nMixin {
    @Prop({
        required: false,
        default: false
    })
    private mode_code!:any;
    @Prop({
        required: false,
        default: false
    })
    private statusTypes!:any[];
    // выводить к дате время смены статуса (ЧЧ:ММ:СС) — вкладки модуля "Внесение изменений"
    @Prop({
        required: false,
        default: false
    })
    private withTime!: boolean;
    private agrObj:any = null;

    private showModal = false;
    private realmUsers:any[] = [];
    private histList:any[] = [];
    private async created() {
    }

    private async showEvent(agrObj: any) {
        if (agrObj === null) return;
        if (!this.realmUsers.length) {
            await this.loadExecutors()
        }
        this.agrObj = agrObj
        this.histList = Object.assign([], agrObj.statusList)
        if (agrObj.hasOwnProperty('status')) {
            this.histList.push(agrObj.status)
        }
        for (const his of this.histList) {
            his.userName = this.getLocalUser(his.user_id)
        }
        // create_date может прийти как ISO-строкой, так и числом — сравниваем по времени
        this.histList.sort((a, b) => this.toTime(b.create_date) - this.toTime(a.create_date));
        this.showModal = true;
    }

    private toTime(value: any): number {
        const time = value ? new Date(value).getTime() : NaN;
        return isNaN(time) ? 0 : time;
    }

    private formatDate(value: any): string {
        if (!value) return '';
        const date = new Date(value);
        if (isNaN(date.getTime())) return '';
        if (!this.withTime) return date.toLocaleDateString();
        return moment(date).format('DD.MM.YYYY HH:mm:ss');
    }

    private getLocalStatus(value:any) {
        const status = value.status;
        const curStatus = this.statusTypes.filter((item) => item.code === status);
        if (!curStatus || !curStatus.length) return status;
        const localName = curStatus[0]["name_" + this.$i18n.locale];
        return localName;
    }

    private async loadExecutors() {
        await axios.get('/api-py/get-realm-users/')
            .then(resp => {
                if (resp.status === 200) {
                    this.realmUsers = resp.data
                }
            }).catch((error:any) => {})
    }

    private getLocalUser(user_id: any) {
        const infoAboutUser = this.realmUsers.find((d:any) => d.id === user_id)
        if (!infoAboutUser) {
            return ''
        }
        let name = ''
        if (infoAboutUser['lastName']) {
            name += infoAboutUser['lastName']
        }
        if (infoAboutUser['firstName']) {
            name += ' ' + infoAboutUser['firstName']
        }
        return name
    }

}
